import { useSelector } from 'react-redux'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Actions from 'components/App/DesktopView/shared/Composer/Header/Actions'
import { selectIsLoggingNewConversation } from 'selectors/page'

import RecipientsEditor from './RecipientsEditor'
import withEditMode from './withEditMode'
import Label from './Label'

const ToRow = ({
  bccVisible,
  ccVisible,
  children, // e.g. FormSwitcherButton
  className,
  editing,
  fromVisible,
  onActionClick,
  subjectVisible,
  ticketId,
  onUpdate,
  shouldShowActions,
  ...rest
}) => {
  const isLogging = useSelector(selectIsLoggingNewConversation)

  return (
    <div className={cn(className, 'grui', 'flex')}>
      {children}
      <div
        className={cn(
          'toEditor grui flex',
          { 'grui ml-4': !!children },
          { 'grui ml-0': !children }
        )}
        css={css`
          min-width: 0;
          flex: 1 1 60%;
          min-height: 26px;
        `}
      >
        <Label>{isLogging ? 'Customer' : 'To'}:</Label>
        <RecipientsEditor
          key={`recipientseditor-to-${ticketId}`}
          className="grui ml-3"
          type="to"
          ticketId={ticketId}
          onUpdate={onUpdate}
          {...rest}
        />
      </div>
      {shouldShowActions && (
        <div className="grui flex actions">
          <Actions
            hideBcc={bccVisible}
            hideCc={ccVisible}
            hideFrom={fromVisible}
            hideSubject={subjectVisible}
            onClick={onActionClick}
          />
        </div>
      )}
    </div>
  )
}

ToRow.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  recipientsOpenUpward: PropTypes.bool,
}

ToRow.defaultProps = {
  recipientsOpenUpward: false,
}

export default styled(withEditMode(ToRow))`
  .label {
    line-height: 26px; /* hacks around jumpy label as you remove recipient */
  }

  .actions {
    line-height: 2;
  }
`
